<template>
    <div class="PreferentialManagement" v-loading.fullscreen.lock="fullscreenLoading" :style="{ height: Height - 105 + 'px'}">
        <el-container :style="{ height: Height - 105 + 'px'}">
            <el-header height="80px">
                <el-row>
                    <el-col>
                        <h2>优惠管理</h2>
                    </el-col>
                    <el-col :span="12" style="text-align: left; padding-left: 10px;">
                        <el-popover
                            placement="bottom-start"
                            width="400"
                            trigger="manual"
                            v-model="visible">
                            <el-form ref="ruleForms" :model="queryform" label-width="100px">
                                <el-form-item label="公司名称">
                                    <!-- <el-input v-model="queryform.keyword"></el-input> -->
                                    <el-select v-model="queryform.keyword" filterable remote placeholder="请选择" :remote-method="remoteMethod" :loading="loading">
                                        <el-option v-for="item in CompanyList" :key="item.id" :label="item.title" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                            <el-row>
                                <el-col style="text-align: right;">
                                    <el-button type="primary" @click="Reset">重置</el-button>
                                    <el-button type="primary" @click="ConfirmQuery">确认</el-button>
                                </el-col>
                            </el-row>
                            <el-button type="primary" slot="reference" @click="visible = !visible">查询</el-button>
                        </el-popover>
                    </el-col>
                    <el-col :span="12">
                        <el-button type="primary" @click="AddPreferentialManagement">新增</el-button>
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <el-table :data="tableData" border style="width: 100%" :height="Height - 265">
                    <el-table-column prop="title" label="优惠标题" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="company_name" label="公司">
                    </el-table-column>
                    <el-table-column prop="type" label="优惠类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.type === 0">折扣</span>
                            <span v-if="scope.row.type === 1">满减</span>
                        </template>
                    </el-table-column>
                     <el-table-column prop="type" label="优惠场地">
                        <template slot-scope="scope">
                            <span v-if="scope.row.space_type === 1">会议室</span>
                            <span v-if="scope.row.space_type === 2">直播间</span>
                            <span v-if="scope.row.space_type === 3">路演厅</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="dDateS" label="优惠开始日期" align="center">
                        <template slot-scope="scope">
                            <span>{{scope.row.dDateS}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="dDateE" label="优惠结束日期" align="center">
                        <template slot-scope="scope">
                            <span>{{scope.row.dDateE}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="优惠状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status === 1">正常</span>
                            <span v-if="scope.row.status === 2">废除</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="总优惠次数">
                        <template slot-scope="scope">
                            {{scope.row.times}}次
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="已优惠次数">
                        <template slot-scope="scope">
                            {{scope.row.used}}次
                        </template>
                    </el-table-column>
                    <el-table-column prop="zhekou" label="优惠">
                        <template slot-scope="scope">
                            <span v-if="scope.row.type === 0">{{scope.row.zhekou}}折</span>
                            <span v-if="scope.row.type === 1">满{{scope.row.man}}减{{scope.row.jian}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="content" label="备注" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="address" label="操作" align="center" width="135px">
                        <template slot-scope="scope">
                            <el-button type="text" @click="EditPreferential(scope.row)">编 辑</el-button>
                            <el-button type="text" @click="DeletePreferential(scope.row)">删 除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog :title="title" :visible.sync="Preferential" top="7vh" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="Preferential">
                    <el-form :model="form" :rules="rules" ref="ruleForm">
                        <el-form-item label="优惠标题" label-width="80px" prop="title">
                            <el-input v-model="form.title"></el-input>
                        </el-form-item>
                        <el-form-item label="公司" label-width="80px" prop="company_id">
                            <el-select v-model="form.company_id" filterable remote placeholder="请选择" :remote-method="remoteMethod" :loading="loading">
                                <el-option v-for="item in CompanyList" :key="item.id" :label="item.title" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="场地类型" label-width="80px" prop="space_type">
                            <el-select v-model="form.space_type" placeholder="请选择">
                                <el-option v-for="item in SpaceTypeList" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="优惠类型" label-width="80px" prop="type">
                            <el-select v-model="form.type" placeholder="请选择">
                                <el-option v-for="item in TypeList" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="优惠状态" label-width="80px" prop="status">
                            <el-select v-model="form.status" placeholder="请选择">
                                <el-option v-for="item in StatusList" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="次数" label-width="80px">
                            <el-input v-model="form.times"></el-input>
                        </el-form-item>
                        <el-form-item label="折扣" label-width="80px" v-if="form.type === 0">
                            <el-input v-model="form.zhekou"></el-input>
                        </el-form-item>
                        <el-form-item style="display: inline-block; width: 50%;" label="满" label-width="80px" v-if="form.type === 1">
                            <el-input v-model="form.man"></el-input>
                        </el-form-item>
                        <el-form-item style="display: inline-block; width: 50%;" label="减" label-width="40px" v-if="form.type === 1">
                            <el-input v-model="form.jian"></el-input>
                        </el-form-item>
                        <el-form-item label="期限" label-width="80px" prop="dDate">
                            <el-date-picker
                                v-model="form.dDate"
                                type="daterange"
                                align="right"
                                unlink-panels
                                value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="备注" label-width="80px">
                            <el-input type="textarea" v-model="form.content"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="Preferential = false">取 消</el-button>
                        <el-button type="primary" @click="confirmPreferential" :loading="confirmloding">确 定</el-button>
                    </div>
                </el-dialog>
            </el-main>
            <el-footer>
                <el-row>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="total"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="12" style="text-align: center;">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="->, sizes"
                            :total="total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-footer>
        </el-container>
  </div>
</template>

<script>
/*eslint-disable */
import { getToken, getAdminId } from "../../../utils/auth";
import https from "../../../utils/http";
export default {
    name: "PreferentialManagement",
    data () {
        return {
            http: https.http,
            visible: false,
            fullscreenLoading: false,
            tableData: [],
            queryform: {
                keyword: ''
            },
            currentPage: 1,
            Size: 20,
            total: 1,
            Preferential: false,
            title: '',
            form: {
                title: '',
                type: 0,
                space_type: 1,
                content: '',
                dDate: [],
                dDateS: '',
                dDateE: '',
                status: 1,
                zhekou: '',
                times: '',
                man: '',
                jian: '',
                company_id: ''
            },
            SpaceTypeList: [{
                label: '会议室',
                value: 1
            }, {
                label: '直播间',
                value: 2
            }, {
                label: '路演厅',
                value: 3
            }],
            TypeList: [{
                label: '折扣',
                value: 0
            }, {
                label: '满减',
                value: 1
            }],
            StatusList: [{
                label: '正常',
                value: 1
            }, {
                label: '废除',
                value: 2
            }],
            CompanyList: [],
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            loading: false,
            rules: {
                title: [
                    { required: true, message: '请输入优惠标题', trigger: 'blur' }
                ],
                company_id: [
                    { required: true, message: '请选择公司', trigger: 'blur' }
                ],
                space_type: [
                    { required: true, message: '请选择场地类型', trigger: 'blur' }
                ],
                type: [
                    { required: true, message: '请选择优惠类型', trigger: 'blur' }
                ],
                status: [
                    { required: true, message: '请选择优惠状态', trigger: 'blur' }
                ],
                zhekou: [
                    { required: true, message: '请输入折扣', trigger: 'blur' }
                ],
                man: [
                    { required: true, message: '请输入满多少', trigger: 'blur' }
                ],
                jian: [
                    { required: true, message: '请输入减多少', trigger: 'blur' }
                ],
                dDate: [
                    { required: true, message: '请选择期限', trigger: 'blur' }
                ]
            },
            confirmloding: false
        }
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        AddPreferentialManagement () {
            this.title = '新增优惠'
            this.Preferential = true
            this.form = {
                title: '',
                type: 0,
                space_type: 1,
                content: '',
                dDate: [],
                dDateS: '',
                dDateE: '',
                status: 1,
                zhekou: '',
                times: '',
                man: '',
                jian: '',
                company_id: ''
            }
        },
        handleSizeChange(size) {
            this.Size = size
            this.GetPreferentialManagementList()
        },
        handleCurrentChange(page) {
            this.currentPage = currentPage
            this.GetPreferentialManagementList()
        },
        Reset () {
            this.queryform = {
                keyword: ''
            }
        },
        ConfirmQuery () {
            this.currentPage = 1
            this.GetPreferentialManagementList()
        },
        GetPreferentialManagementList () {
            let data = {
                limit: this.Size,
                page: this.currentPage,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken(),
                company_id: this.queryform.keyword
            }
            this.$store.dispatch('PreferentialManagementListShow', data).then(res => {
                for (let item in res.data) {
                    res.data[item].dDateS = res.data[item].dDateS.split(' ')[0];
                    res.data[item].dDateE = res.data[item].dDateE.split(' ')[0];
                }
                this.total = res.something
                this.fullscreenLoading = false
                this.tableData = res.data
                this.visible = false
            })
        },
        remoteMethod (query) {
            if (query !== '') {
                this.loading = true
                let data = {
                    keyword: query,
                    room: '',
                    limit: 100,
                    page: 1,
                    ADMIN_ID: getAdminId(),
                    ADMIN_TOKEN: getToken(),
                    status: 1
                }
                this.$store.dispatch('CompanyListShow', data).then(res => {
                    this.CompanyList = res.data
                    this.loading = false
                })
            } else {
                this.CompanyList = []
            }
        },
        GetCompanyList () {
            let data = {
                keyword: '',
                room: '',
                limit: 10000,
                page: 1,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.$store.dispatch('CompanyListShow', data).then(res => {
                this.CompanyList = res.data
            })
        },
        SetPreferential (data) {
            this.confirmloding = true
            this.$store.dispatch('SavePreferential', data).then(res => {
                if (res.flag) {
                    this.$message({
                        message: res.message,
                        type: 'success'
                    })
                    this.$refs['ruleForm'].resetFields();
                    this.Preferential = false
                    this.fullscreenLoading = true
                    this.confirmloding = false
                    this.GetPreferentialManagementList()
                } else {
                    this.confirmloding = false
                    this.$message({
                        message: res.message,
                        type: 'warning'
                    })
                }
            })
        },
        confirmPreferential () {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    let data = JSON.parse(JSON.stringify(this.form))
                    data.ADMIN_ID = getAdminId()
                    data.ADMIN_TOKEN = getToken()
                    data.dDateS = data.dDate[0]
                    data.dDateE = data.dDate[1] + ' ' + '23:59:59'
                    if (data.type === 0) {
                        if (data.zhekou === '') {
                            this.$message({
                                message: '请输入折扣',
                                type: 'warning'
                            })
                        } else if (data.zhekou !== '') {
                            this.SetPreferential(data)
                        }
                    } else if (data.type === 1) {
                        if (data.man !== '' && data.jian !== '') {
                            this.SetPreferential(data)
                        } else if (data.man === '') {
                            this.$message({
                                message: '请输入满多少',
                                type: 'warning'
                            })
                        } else if (data.jian === '') {
                            this.$message({
                                message: '请输入减多少',
                                type: 'warning'
                            })
                        }
                    }
                } else {
                    return false;
                }
            })
        },
        EditPreferential (row) {
            this.title = '编辑优惠'
            this.Preferential = true
            this.form = JSON.parse(JSON.stringify(row))
            this.form.dDate = []
            this.form.dDate[0] = this.form.dDateS
            this.form.dDate[1] = this.form.dDateE
        },
        DeletePreferential (row) {
            this.$confirm('是否删除该优惠？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = JSON.parse(JSON.stringify(row))
                data.ADMIN_ID = getAdminId()
                data.ADMIN_TOKEN = getToken()
                this.$store.dispatch('DeletePreferential', data).then(res => {
                    if (res.flag) {
                        this.$message({
                            message: res.message,
                            type: 'success'
                        });
                        this.fullscreenLoading = true
                        this.GetPreferentialManagementList()
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        });
                    }
                })
            }).catch(() => {
            });
        }
    },
    created() {
        this.fullscreenLoading = true
        this.GetCompanyList()
        this.GetPreferentialManagementList()
    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height;
        }
    }
}
</script>

<style>
.PreferentialManagement {
    width: 100%;
}
.PreferentialManagement .el-header .el-row .el-col {
    height: 40px;
    line-height: 40px;
}
.PreferentialManagement .el-header .el-row .el-col h2 {
    text-align: center;
}
.PreferentialManagement .el-header .el-row .el-col {
    text-align: center;
}
.PreferentialManagement .el-header .el-row .el-col:last-child {
    text-align: right;
}
.PreferentialManagement .el-main {
    padding-top: 0px;
    padding-bottom: 0px;
}
.PreferentialManagement .el-main .Preferential .el-form-item:nth-child(2), .PreferentialManagement .el-main .Preferential .el-form-item:nth-child(3), .PreferentialManagement .el-main .Preferential .el-form-item:nth-child(4), .PreferentialManagement .el-main .Preferential .el-form-item:nth-child(5) {
    display: inline-block;
    width: 50%;
}
.PreferentialManagement .el-main .Preferential .el-form-item .el-select, .PreferentialManagement .el-main .Preferential .el-form-item .el-date-editor {
    width: 100%;
}
.PreferentialManagement .el-main .Preferential .el-dialog__body {
    padding-bottom: 0px;
    padding-top: 0px;
}
</style>
